(function($, window, document, undefined) {

    var pluginName = 'getPricing';

    var defaults = {
        modal: '#getInfo',
        submitTrigger: '.js-get-pricing-submit',
        wp_action: 'get_price'
    };

    function GetPricing(element) {
        this.settings = $.extend({}, defaults);
        this.$element = $(element);

        this.init();
    }

    GetPricing.prototype.init = function() {
        var self = this;

        this.$element.on('click', function(e) {
            e.preventDefault();

            self.submitPricing();
        });
    };

    GetPricing.prototype.destroy = function() {
        $(document).off('click', this.settings.submitTrigger);
    };

    GetPricing.prototype.submitPricing = function() {
        var self = this;
        var data = {
            action: self.settings.wp_action,
            offer_id: self.$element.attr('data-id'),
            plan_name: self.$element.attr('data-name')
        };

        var $form = self.$element.parents('form');

        var erros = self.validateForm($form);
        if (erros.length > 0) {
            for (var i = 0, ln = erros.length; i < ln; i++) {
                $(erros[i].selector).siblings('.message').removeClass('hidden');
            }
            return false;
        }

        $form.find('input').each(function() {
            var $input = $(this);

            if ($input.attr('name') === 'users_count') {
                data[$input.attr('name')] = parseInt($input.val());
            } else {
                data[$input.attr('name')] = $input.val();
            }
        });

        $.ajax({
            method: 'POST',
            url: ajaxUrl,
            dataType: 'json',
            data: data
        }).done(function(response) {
            if (response.success === true && response.data.length > 0) {
                var price = false;
                var $modal = $(self.settings.modal);

                for (var i = 0, ln = response.data.length; i < ln; i++) {
                    var plan = response.data[i];
                    var usersCount = data.users_count;

                    var $hidden = $('a[data-id="' + data.offer_id + '"][data-name="' + plan.name + '"]')
                        .parents('.price-block')
                        .find('.js-price-list');

                    if ($hidden) {
                        if (usersCount > 300) {
                            price = plan['400'] ? plan['400'] : plan['300'] ? plan['300'] : plan['200'] ? plan['200'] : plan['100'] ? plan['100'] : plan['50'];
                        } else if (usersCount > 200 && usersCount <= 300) {
                            price = plan['300'] ? plan['300'] : plan['200'] ? plan['200'] : plan['100'] ? plan['100'] : plan['50'];
                            if (!price) {
                                price = plan['400'] ? plan['400'] : false;
                            }
                        } else if (usersCount > 100 && usersCount <= 200) {
                            price = plan['200'] ? plan['200'] : plan['100'] ? plan['100'] : plan['50'];
                            if (!price) {
                                price = plan['300'] ? plan['300'] : plan['400'] ? plan['400'] : false;
                            }
                        } else if (usersCount > 50 && usersCount <= 100) {
                            price = plan['100'] ? plan['100'] : plan['50'];
                            if (!price) {
                                price = plan['200'] ? plan['200'] : plan['300'] ? plan['300'] : plan['400'] ? plan['400'] : false;
                            }
                        } else if (usersCount <= 50) {
                            price = plan['50'];
                            if (!price) {
                                price = plan['100'] ? plan['100'] : plan['200'] ? plan['200'] : plan['300'] ? plan['300'] : plan['400'] ? plan['400'] : false;
                            }
                        }

                        if (price) {
                            $modal.modal('hide');
                            $hidden.find('h1').html('<sup>$</sup>' + parseFloat(price).toFixed(2));
                            $hidden.hide();
                            $hidden.removeClass('hidden');
                            $hidden.show('slow');
                        }
                    }
                }
            }
        });
    };

    GetPricing.prototype.validateForm = function($form) {
        var erros = [];

        $form.find('.message').addClass('hidden');

        $form.find('input').each(function() {
            var $input = $(this);

            if ($input.hasClass('required')) {

                if (!$input.val()) {
                    erros.push({selector: '#' + $input.attr('id')});
                }

                if ($input.attr('name') === 'users_count' && !parseInt($input.val())) {
                    erros.push({selector: '#' + $input.attr('id')});
                }
            }
        });

        return erros;
    };

    $.fn[pluginName] = function(options) {
        return this.each(function() {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new GetPricing(this, options));
            }
        });
    };

})(jQuery, window, document);